import type { FormApi } from "@tanstack/react-form";
import { makePathArray } from "@tanstack/react-form";
import type { z } from "zod";
import { ZodArray, ZodNullable, ZodOptional } from "zod";

export const onSubmit =
  (callback?: () => void) =>
  (
    e:
      | React.MouseEvent<HTMLButtonElement | HTMLDivElement>
      | React.FormEvent<HTMLFormElement>
  ) =>
    stopPropagation(e, callback);

export const stopPropagation = (
  e:
    | React.MouseEvent<HTMLButtonElement | HTMLDivElement>
    | React.FormEvent<HTMLFormElement>,
  callback?: () => void
) => {
  e.preventDefault();
  e.stopPropagation();
  if (callback) {
    callback();
  }
};

// Only used with zodValidator from tanstack/react-form, only verify last field level condition
export const getOnChangeFromZod = <TFormData>(
  schema: z.ZodType<TFormData>,
  name: string
) => {
  let zod: any = schema;
  const path = makePathArray(name);
  for (const key of path) {
    while (
      zod instanceof ZodOptional ||
      zod instanceof ZodNullable ||
      zod instanceof ZodArray
    ) {
      zod = zod instanceof ZodArray ? zod.element : zod._def.innerType;
    }
    if (typeof key === "number") continue;
    zod = zod?.shape?.[key];
  }
  return zod;
};

export const yesNoRadioOptions = [
  { value: "true", label: "Oui" },
  { value: "false", label: "Non" },
];

export const noYesRadioOptions = [
  { value: "false", label: "Non" },
  { value: "true", label: "Oui" },
];

type AnyFormApi<T> = FormApi<
  T,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any
>;

export const resetForm = <TFormData>(
  value: TFormData,
  formApi: AnyFormApi<TFormData>
) => {
  formApi.update({ defaultValues: value });
  formApi.reset();
};

export const handleMinMax = (
  value: string | number | null,
  min: string | number | undefined,
  max: string | number | undefined
): number | null => {
  const valueNumber = value === null ? NaN : +value;
  if (isNaN(valueNumber)) return null;
  if (min !== undefined && valueNumber < +min) return +min;
  else if (max !== undefined && valueNumber > +max) return +max;
  else return valueNumber;
};
